import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BaseWebsocketMessage,
  InsWebsocketMessageRequest,
  QueryWebsocketMessageRequest,
  SubWebsocketMessageRequest,
  UpdWebsocketMessageRequest,
  WebsocketEntTypes,
  WebSocketService,
  WSEntityManager,
} from '@qtek/core/websockets-core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AiChatService {
  private readonly entChat: WebsocketEntTypes = 'chat';
  private readonly entEvent: WebsocketEntTypes = 'chatEvent';

  private chatMgr = new WSEntityManager(this.ws, this.entChat);
  private eventMgr = new WSEntityManager(this.ws, this.entEvent);

  constructor(
    private ws: WebSocketService,
    private http: HttpClient
  ) {}

  subscribeChats(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>
  ): Observable<BaseWebsocketMessage> {
    const clean = { ...payload };
    delete (clean as any).cmd;
    return this.chatMgr.subscribeEntity(clean, false);
  }

  queryChats(payload: Omit<QueryWebsocketMessageRequest, 'ent' | 'op'>) {
    this.chatMgr.query(payload);
  }

  createChat(payload: Omit<InsWebsocketMessageRequest, 'ent' | 'op'>) {
    const minimal: any = { ...(payload || {}) };
    delete minimal.res;
    this.chatMgr.create(minimal);
  }

  updateChat(payload: Omit<UpdWebsocketMessageRequest, 'ent' | 'op'>) {
    this.chatMgr.update(payload);
  }

  subscribeChatEvents(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>
  ): Observable<BaseWebsocketMessage> {
    const clean = { ...payload };
    delete (clean as any).cmd;
    return this.eventMgr.subscribeEntity(clean, false);
  }

  queryChatEvents(payload: Omit<QueryWebsocketMessageRequest, 'ent' | 'op'>) {
    this.eventMgr.query(payload);
  }

  sendEvent(payload: Omit<InsWebsocketMessageRequest, 'ent' | 'op'>) {
    this.eventMgr.create(payload);
  }

  submitFeedback(body: {
    messageId: string;
    rating: 'positive' | 'negative';
    comment?: string;
  }): Observable<unknown> {
    return this.http.post('/api/v1/allo/feedback', body, {
      withCredentials: true,
    });
  }
}
